import { main_link } from "../Connection/Connection";
import useFetch from "../Fetch_Folder/useFetch";
import { useState, useEffect, useRef } from "react";

import { FilterMatchMode, FilterService } from "primereact/api";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";

import axios from "axios";
import Spinner from "react-bootstrap/Spinner";

//
const RemovedCustomers = () => {
  const toast = useRef(null);
  const user = JSON.parse(sessionStorage.getItem("user-data"));
  const user_id = user["encrypted_id"];
  const [counter, setCounter] = useState(0);

  const [filters, setFilters] = useState({
    name: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });

  const {
    error,
    isLoading,
    data: getRemovedCustomers,
  } = useFetch(`${main_link}getRemovedCustomers?user_id=${user_id}`, counter);

  //   console.log(getRemovedCustomers);
  const restoreTemplate = (rowData) => (
    <Button
      type="button"
      icon="nav-icon fas fa-reply"
      style={{ borderRadius: "50px" }}
      onClick={() => {
        restore(rowData.cust_id, rowData.name);
      }}
    />
  );

  const restore = async (cust_id, name) => {
    var answer = window.confirm("Are you sure you want to " + name);
    if (answer) {
      try {
        const response = await axios.post(main_link + "restore_customer", {
          cust_id,
          user_id,
        });

        // console.log(response.data);

        if (response.data.message == "Restored Successfully.") {
          toast.current.show({
            severity: "success",
            summary: "success",
            detail: "Customer Restored Successfully.",
          });
          setCounter(counter + 1);
        }

        if (
          response.data.message ==
          "You can't restore a customer who doesn't belong to your customers."
        ) {
          toast.current.show({
            severity: "info",
            summary: "info",
            detail:
              "You can't restore a customer who doesn't belong to your customers.",
          });
          setCounter(counter + 1);
        }
      } catch (error) {
        // console.log(error);
      }
    }
  };
  return (
    <>
      {" "}
      <Toast ref={toast} />
      <div>
        {/* Content Wrapper. Contains page content */}
        <div className="content-wrapper">
          {/* Content Header (Page header) */}
          <section className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h1>Removed Customers</h1>
                </div>
              </div>
            </div>
            {/* /.container-fluid */}
          </section>
          {/* Main content */}
          <section className="content">
            {/* Default box */}
            <div className="card">
              <div className="card-header">
                <h3 className="card-title">
                  Removed Customers{" "}
                  {isLoading && (
                    <Spinner
                      size="sm"
                      animation="border"
                      role="status"
                    ></Spinner>
                  )}
                </h3>
              </div>
              <DataTable
                value={getRemovedCustomers}
                sortMode="multiple"
                tableStyle={{ minWidth: "50rem" }}
                paginator
                rows={10}
                dataKey="index"
                filters={filters}
                filterDisplay="row"
                loading={isLoading}
                scrollable
                removableSort
                stripedRows
              >
                <Column
                  field="index"
                  header="ID"
                  sortable
                  filter
                  filterPlaceholder="Search by ID"
                  style={{ width: "10 %" }}
                ></Column>
                <Column
                  field="name"
                  header="Name"
                  sortable
                  style={{ width: "15%" }}
                  filter
                  filterPlaceholder="Search by name"
                ></Column>
                <Column
                  field="email"
                  header="Email"
                  sortable
                  filter
                  filterPlaceholder="Search by email"
                  style={{ width: "25%" }}
                ></Column>
                <Column
                  field="created_by_name"
                  header="Created By"
                  sortable
                  style={{ width: "25%" }}
                  filter
                  filterPlaceholder="Search by created by"
                ></Column>
                <Column
                  field="created_at_at"
                  header="Created At"
                  sortable
                  filter
                  filterPlaceholder="Search by date"
                  style={{ width: "25%" }}
                ></Column>
                <Column
                  header="Edit"
                  headerStyle={{ width: "5rem", textAlign: "center" }}
                  bodyStyle={{ textAlign: "center", overflow: "visible" }}
                  body={restoreTemplate}
                />
              </DataTable>

              {/* /.card-body */}
              <div className="card-footer">RemovedCustomers</div>
              {/* /.card-footer*/}
            </div>
            {/* /.card */}
          </section>
          {/* /.content */}
        </div>
        {/* /.content-wrapper */}
      </div>
    </>
  );
};

export default RemovedCustomers;
